import type { BuiltInExteriorPropId } from "building-types/props/builtInExteriorPropId";
import type { PropAsset } from "building-types/props/PropAsset";
import type { PropInstance } from "building-types/props/propInstanceTypes";
import type { PropAttributeTable } from "building-types/props/propTypes";
import { defaultExteriorPropCatalog } from "doc/elements/propCatalog/exteriorPropCatalog";
import type { BuiltInInteriorPropId } from "doc/elements/propCatalog/interiorPropCatalog";
import type { MergedPropLibrary } from "doc/propTools";
import { defaultExteriorPropSettings } from "doc/settings/defaultSettings";

export function sortPropCatalogOptions(propCatalog: PropAttributeTable) {
  return Object.keys(propCatalog || {})
    .filter((id) => id !== "type")
    .sort((a, b) => a.localeCompare(b));
}

export async function getPropSrc(
  propCatalog: PropAttributeTable,
  propId: BuiltInExteriorPropId | BuiltInInteriorPropId | string | undefined,
  mergedPropLibrary: MergedPropLibrary,
): Promise<PropAsset | null> {
  if (!propId) {
    return null;
  }

  const prop = propCatalog[propId];

  if (!prop) {
    return null;
  }

  return (await mergedPropLibrary.get(prop.propAssetId)) ?? null;
}

export function isSystemProp(prop: PropInstance): boolean {
  return !!(defaultExteriorPropCatalog[prop.propType] || defaultExteriorPropSettings[prop.propType]);
}
